import wretcher from "@/services/wretcher";
import type { FrontEndTraceLogType } from "@/actions/entities/trace.type";

export default async function frontEndTraceLog(req: FrontEndTraceLogType[]) {
  return await wretcher.url("/api/System/FrontEndTraceLog").post(req).json();
}
